import { create } from 'zustand';

import { BffPsaResponse } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';

interface State {
  psaMessage: BffPsaResponse['message'];
  loading: boolean;
  error: boolean;
  isShown: boolean;
}

interface Actions {
  fetch: () => void;
  setIsShown: (isShown: boolean) => void;
}

export const usePsaStore = create<State & Actions>(set => ({
  psaMessage: null,
  loading: false,
  error: false,
  isShown: true,
  setIsShown: (isShown: boolean) => set({ isShown }),
  fetch: async () => {
    set({
      loading: true,
      error: false,
    });
    try {
      const response = await BffApiService.getPsa();
      set({
        loading: false,
        error: false,
        psaMessage: response.data.data?.message,
        isShown: true,
      });
    } catch {
      set({
        loading: false,
        error: true,
        isShown: false,
      });
    }
  },
}));
